import { useNavigate } from "react-router-dom";

export default function AICommandCenterPreview() {

  const navigate = useNavigate();

  return (
    <div
      style={{
        maxWidth: "900px",
        margin: "60px auto",
        padding: "30px",
        textAlign: "center"
      }}
    >
      <h1>Agentic AI Command Center</h1>

      <p>
        Agentic AI–Powered Safety Intelligence & Situational Awareness Platform.
      </p>

<ul
  style={{
    textAlign: "left",
    maxWidth: "600px",
    margin: "30px auto"
  }}
>
  <li>Agentic AI Safety Intelligence</li>
  <li>Environmental Risk Monitoring</li>
  <li>Autonomous Threat Signal Analysis</li>
  <li>Predictive Risk Assessment</li>
  <li>AI-Assisted Operational Decision Support</li>
  <li>Early Warning & Alert Prioritization</li>
  <li>School Safety Situational Awareness</li>
</ul>
<p>
  FentaSafe combines Agentic AI, environmental sensing, and adaptive
  decision-support capabilities to help educational institutions identify,
  assess, and respond to emerging safety risks in real time.
</p>
      <p>
        Access is available during authorized demonstrations and pilot evaluations.
      </p>

      <button
        onClick={() => navigate("/contact")}
        style={{
          padding: "12px 24px",
          cursor: "pointer"
        }}
      >
        Request Demo
      </button>
    </div>
  );
}